
import React from 'react';
import { useSelector,useDispatch } from 'react-redux'
import { Grid, Checkbox, Button, Group, Loader, TextInput, ScrollArea, Modal, Text, Alert, Badge,Indicator, Tabs, createStyles, Tooltip} from '@mantine/core';
import { useEffect, useState } from 'react';
import { setsetupnotar,set_docstoconvert, cleare_update_DocsPrepareTemp_Status, setup_user_todocs, update_localdoc_signstate, update_localdoc_readstate, remove_doc_from_all_stapels } from '../slice/mainslice';
import PdfLabel from './helper/PdfLabel';

import { FileText, Article,  Pencil, ArrowUpCircle, DiscountCheck,Users, FileSettings, Stack2} from 'tabler-icons-react';

import SetupUserToDocs from './helper/SetupUserToDocs';
import SetupUserToDocsHeader from './helper/SetupUserToDocsHeader';
import SetupPrepareDocs from './helper/SetupPrepareDocs';
import SetupStapelSign from './helper/SetupStapelSign';

import SetupUserToIdentify from './helper/SetupUserToIdentify';

import intl from 'react-intl-universal';
import { notifications } from '@mantine/notifications';

let nostapelshow = true

const useStyles = createStyles((theme) => ({
  pafleft10:{
      paddingLeft: 3,
  },
  pafleft2:{
    paddingLeft: 1,
},
margintop: {
  marginTop: `5px`,
},
minheight: {
paddingTop: `20px`,
},
selectallrow: {
  backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[1],
  borderRadius: theme.radius.sm,
  alignItems: 'center',
  paddingTop: 3,
  paddingBottom: 3,
},
buttonfloat: {
  background: '#333333',
},
}));


 

const SetupMeeting = (props:any) => {
const dispatch = useDispatch()
const { classes } = useStyles(); 
const meetinginfo = useSelector((state: any) => state.user.meetinginfo)
const initdocsinmeeting = useSelector((state: any) => state.user.meetingdocs) || []
const usertoident = useSelector((state: any) => state.user.userhavetoident)


const userhavetosigndocs = useSelector((state: any) => state.user.userhavetosigndocs)
const updatesetblockstatus = useSelector((state: any) => state.user.meetingdocspreparestatus)
const[docsinmeeting, setDocsinmeeting] = useState<any>(initdocsinmeeting);

const stapeluser = useSelector((state: any) => state.user.userhavetostapelsigndocs) || [];

//Stapel
//const userhavetostapelsigndocs = useSelector((state: any) => state.user.userhavetostapelsigndocs)
//const hasstapelchanges = useSelector((state: any) => state.user.userhavechangestapel)

const[docstoconvert, setDocsToConvert] = useState<any>();

const [vorname, setVorname] = useState('');
const [famname, setFamname] = useState('');

const [pdfhavesigns, setPdfhavesigns] = useState(false);
const [opened, setOpened] = useState(false);
const [forceconsvert, setforceconsvert] = useState(false);

const [screenHeight, setScreenHeight] = useState(window.innerHeight - 440);

const [disableonSigSetup, setDisableonSigSetup] = useState(false);

// Help PArameter to enable or disable the Prepare SIgBlocks Button
let disablesigblock = false


//console.log("docsinmeeting",docsinmeeting)

//console.log(userhavetosigndocs)
//console.log(docsinmeeting[0].isSigPrepared)
// Use useEffect to update local state when Redux data (initdocsinmeeting) changes
  useEffect(() => {
    // This effect runs:
    if (initdocsinmeeting) {
      // Create a new array that incorporates the Redux data
      // and any local state (like selection status) you want to preserve.
      const updatedDocs = initdocsinmeeting.map((reduxDoc: any) => {
        // Find if this document already exists in our local state to preserve its selection
        const existingLocalDoc = docsinmeeting.find(
          (localDoc: any) => localDoc.id === reduxDoc.id
        );
        return {
          ...reduxDoc, // Copy all properties from the Redux document
          // If it existed locally, use its isSelected status, otherwise default to false
          isSelected: existingLocalDoc ? existingLocalDoc.isSelected : false,
        };
      });
      setDocsinmeeting(updatedDocs);
    }
  }, [initdocsinmeeting]);


//console.log("docsinmeeting",docsinmeeting)

useEffect(() => {
    /**
     * Updates the screen height by subtracting 440 pixels from the window's inner height.
     *
     * @return {void} 
     */
  const handleResize = () => {
    setScreenHeight(window.innerHeight - 440 );
  };

  window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);


// Auf Basis der Screenhöhe den Button im Modalen View halten
// Ab einer Dokumente Anzahl und Screenhöhe den ScrollModua Aktivieren
let scroll = false

if (docsinmeeting?.length >= 10 && screenHeight < 550) {
  scroll = true
}


let disable = false
const countmeetingdocs:any = Object.values(initdocsinmeeting);
//console.log(countmeetingdocs.length)
//console.log("Docs",initdocsinmeeting)

if (countmeetingdocs.length === 0 || disableonSigSetup){
  disable = true
}

const handleisToRead = (value: boolean, index: number) => {
    let newDocsimmeeting = JSON.parse(JSON.stringify(docsinmeeting));
    newDocsimmeeting[index].isToBeRead = value;
    if (value === true) {
      newDocsimmeeting[index].isToBeSigned = true;
      dispatch(update_localdoc_signstate({
        resourceId: newDocsimmeeting[index].resourceId,
        isToBeSigned: true
      }));
    }
    if (value === false) {
      dispatch(remove_doc_from_all_stapels({
        resourceId: newDocsimmeeting[index].resourceId
      }));
      
      stapeluser.forEach((item: {id: any; documentsSignModes: any[]; }) => {
        if (!item.id || !Array.isArray(item.documentsSignModes)) return;
        const remaining = item.documentsSignModes.filter(
          (doc: any) => doc.resourceId !== newDocsimmeeting[index].resourceId
        );
        if (remaining.length === item.documentsSignModes.length) return;
        if (remaining.length === 0) {
          dispatch({ type: 'SIGNALR_REMOVESTAPEL', payload: { StapelId: item.id } });
        } else {
          dispatch({ type: 'SIGNALR_UPDATESTAPELFORSIGN', payload: {
            StapelId: item.id,
            documentsSignModes: remaining,
          }});
        }
      });
    }

    setDocsinmeeting(newDocsimmeeting);
    dispatch(update_localdoc_readstate({
      resourceId: newDocsimmeeting[index].resourceId,
      isToBeRead: value
    }));
  };

const handleisToBeSigned = (value: boolean, index: number) => {
    //console.log("handleisToBeSigned")
    let newDocsimmeeting = JSON.parse(JSON.stringify(docsinmeeting));

    // Payload for localStore
    const localdocstatepayload = {
      resourceId: newDocsimmeeting[index].resourceId,
      isToBeSigned: value
    }

    newDocsimmeeting[index].isToBeSigned = value;
    //console.log("newDocsimmeeting[index]",newDocsimmeeting[index].isToBeSigned)
    
    if (value === false) {
      newDocsimmeeting[index].isToBeRead = false;
      dispatch(update_localdoc_readstate({
        resourceId: newDocsimmeeting[index].resourceId,
        isToBeRead: false
      }));
      newDocsimmeeting[index].signers = []
      const user_to_docs = {
        resourceId: newDocsimmeeting[index].resourceId,
        user: []
      };
      
      dispatch(setup_user_todocs(user_to_docs))

      // remove all entrys of that Document from Stapelsignatur
      // First get all stapels
      //console.log("stapeluser", newDocsimmeeting[index].resourceId)
      //console.log("stapeluser", stapeluser)

      stapeluser.forEach((item: {id: any; stapelResourceIds: any[]; }) => {
        if (Array.isArray(item.stapelResourceIds)) {
          const filteredResourceIds = item.stapelResourceIds.filter(
            (id) => id !== newDocsimmeeting[index].resourceId
          );
         // console.log("item.stapelResourceIds.length",item.stapelResourceIds.length)
         // console.log("filteredResourceIds.length",filteredResourceIds.length)
          
          if (item.stapelResourceIds.length !== filteredResourceIds.length &&
            filteredResourceIds.length > 0 ) {
            const updateLoad = {
              StapelId: item.id, // Assuming stapelId is available in scope
              ResourceIds: filteredResourceIds,
            };
            //console.log("updateLoad",updateLoad)
            dispatch({ type: 'SIGNALR_UPDATESTAPELFORSIGN', payload: updateLoad });
          }
          if (item.stapelResourceIds.length !== filteredResourceIds.length &&
            filteredResourceIds.length === 0 ) {
              console.log("remove stapel")
              const delLoad = {
                StapelId: item.id
              };
             // console.log("delLoad",delLoad)
              dispatch({ type: 'SIGNALR_REMOVESTAPEL', payload: delLoad});
            }
        }
      });
    




    }


    // Always Update DocStore Local
    dispatch(update_localdoc_signstate(localdocstatepayload))
    
    setDocsinmeeting(newDocsimmeeting);
  };

  const handleSelectAllToBeSigned = (value: boolean) => {
    docsinmeeting.forEach((_item: any, index: number) => {
      handleisToBeSigned(value, index);
    });
  };

  const allToBeSigned = docsinmeeting.length > 0 && docsinmeeting.every((item: any) => item.isToBeSigned);

  const handleSelectAllToBeRead = (value: boolean) => {
   
      docsinmeeting.forEach((_item: any, index: number) => {
        handleisToRead(value, index);
      });
    

      if (value === false) {
        const meetingResourceIds = docsinmeeting.map((item: any) => item.resourceId);

        stapeluser.forEach((item: {id: any; documentsSignModes: any[]; }) => {
          if (!item.id || !Array.isArray(item.documentsSignModes)) return;
          const isInStapel = item.documentsSignModes.some(
            (doc: any) => meetingResourceIds.includes(doc.resourceId)
          );
          if (isInStapel) {
            dispatch({ type: 'SIGNALR_REMOVESTAPEL', payload: { StapelId: item.id } });
          }
        });
      }
  };

  const allToBeRead = docsinmeeting.length > 0 && docsinmeeting.every((item: any) => item.isToBeRead);

  const handleCloseSigninfo = () => {
    setOpened(false);
    removepdfwithsigns()
  };

  const confirmforcekonvert = () => {
    setPdfhavesigns(true)
    setforceconsvert(true)
    setOpened(false);
  }

  const removepdfwithsigns = () => {
    const filteredDocs = docstoconvert.filter((item: { signatureCount: number; }) => item.signatureCount === 0);
    setDocsToConvert(filteredDocs);
    setPdfhavesigns(false)
    setforceconsvert(false)
  }



  /**
   * Updates the state of `docsToConvert` based on the provided `isChecked` and `resourceId`.
   *
   * @param {boolean} isChecked - Indicates whether the checkbox is checked or not.
   * @param {string} resourceId - The ID of the Document resource to convert.
   * @return {void}
   */
  const handleisToBeConverted = (isChecked: boolean, resourceId: string, signatureCount:number) => {
    
    if (!pdfhavesigns && signatureCount >= 1) {
      setOpened(true)
    }
    //console.log(signatureCount)

    setDocsToConvert((prevState: any[] | undefined) => {
        // Check if prevState is undefined or empty
        if (!prevState || prevState.length === 0) {
            return [{ resourceId: resourceId, isChecked: isChecked, signatureCount: signatureCount }];
        }
        // If isChecked is true, update the state or add a new entry
        if (isChecked) {
            const existingItemIndex = prevState.findIndex(docstoconvert => docstoconvert.resourceId === resourceId);
            if (existingItemIndex !== -1) {
                // Update the existing item if resourceId is found
                return prevState.map((docstoconvert, index) => {
                    if (index === existingItemIndex) {
                        return { ...docstoconvert, isChecked: isChecked, signatureCount: signatureCount };
                    }
                    return docstoconvert;
                });
            } else {
                // Add a new entry if resourceId is not found
                return [...prevState, { resourceId: resourceId, isChecked: isChecked, signatureCount: signatureCount }];
            }
        } else {
            // If isChecked is false, remove the entry with matching resourceId
            return prevState.filter(docstoconvert => docstoconvert.resourceId !== resourceId);
        }
    });
};

const sendsetmeeting = (close:boolean) => {

  // Create Maps for quick lookups
  const userhavetosigndocsMap = new Map<string, string[]>();
  userhavetosigndocs.forEach((item: { resourceId: string; user: string[]; }) => {
    userhavetosigndocsMap.set(item.resourceId, item.user);
  });

  
  const updatesetblockstatusMap = new Map<string, boolean>();
  updatesetblockstatus.forEach((item: { resourceId: string; isSigPrepared: boolean; }) => {
    updatesetblockstatusMap.set(item.resourceId, item.isSigPrepared);
  });

  
  
  // Map through the documents and create new objects with updates
  const documentsWithSigners: Document[] = docsinmeeting.map((document: { resourceId: string; signers: any; isSigPrepared: any; }) => {
   // console.log(document)
    // Clone the document to avoid modifying the original
    let updatedDocument = { ...document };

    
  
    // Update the signers if they exist
    if (userhavetosigndocsMap.has(document.resourceId)) {
      updatedDocument = {
        ...updatedDocument,
        signers: userhavetosigndocsMap.get(document.resourceId),
      };
    } else {
      updatedDocument = {
        ...updatedDocument,
        signers: [],
      };
    }
  
    // Update the signature preparation status if it exists
    if (updatesetblockstatusMap.has(document.resourceId)) {
      updatedDocument = {
        ...updatedDocument,
        isSigPrepared: updatesetblockstatusMap.get(document.resourceId),
      };
    } 

    return updatedDocument;
  });
  if(vorname !== "" && famname !== ""){
    const aliastextpayload = {
      drnId: meetinginfo.drnId,
      FirstName: vorname,
      LastName: famname
    };
  dispatch({ type: 'SIGNALR_SEND_ALIAS', payload: aliastextpayload });
  }


  // Sent Setup USer to identify
  if (usertoident.length > 0) {
    const setupuserpayload = {
      drnId: meetinginfo.drnId,
      participants: usertoident
    }
   //console.log(setupuserpayload)
   setTimeout(() => {
     dispatch({ type: 'SIGNALR_SEND_USERTOIDENT', payload: setupuserpayload });
  }, 1000); // Delay for 1 second (1000 milliseconds)
  }



    // Finalys sent complete Setup
    const setmeetingpayload = {
      drnId: meetinginfo.drnId,
      documents: documentsWithSigners
    };

    setTimeout(() => { 
      dispatch({ type: 'SIGNALR_SENDSETUPMEETING', payload: setmeetingpayload });
    }, 1000);
  
  
  if (close){
    dispatch(cleare_update_DocsPrepareTemp_Status())
    }



  

  /*const setupuserpayload = {
    drnId: meetinginfo.drnId,
    participants: usertoident
  }*/


  
  if (Array.isArray(docstoconvert) && docstoconvert.length > 0) {
    const storeArray = docstoconvert.map(item => ({
    resourceId: item.resourceId,
    error: null
    }));

    const resourceIdArray = docstoconvert.map((item: { resourceId: string; }) => item.resourceId);
    const setdocsconvertpayload = {
      drnId: meetinginfo.drnId,
      DocumentResourceIds: resourceIdArray,
      IsForced: forceconsvert
    };
   
    dispatch(set_docstoconvert(storeArray))
    setTimeout(() => {
      dispatch({ type: 'SIGNALR_REQUEST_CONVERTDOKS', payload: setdocsconvertpayload });
    }, 1000); // Delay for 1 second (1000 milliseconds)
   //dispatch({ type: 'SIGNALR_REQUEST_CONVERTDOKS', payload: setdocsconvertpayload });
   
}

 
  
  dispatch(setsetupnotar(false))
  if (close){
  props.close()

  notifications.show({
    title: intl.get('NOTIF_INFO_HEADER'),
    message: intl.get('NOTIF_SETUP_OK'),
    withCloseButton: true,
    autoClose: 5000,
  })
}
}

/**
 * Check if the given file name ends with '.pdf'.
 *
 * @param {string} fileName - The file name to be checked.
 * @return {boolean} True if the file name ends with '.pdf', false otherwise.
 */
const isPDF = (fileName: string): boolean => {
  const lowerCaseFileName = fileName.toLowerCase();
  return lowerCaseFileName.endsWith('.pdf');
};


const getFileExtension = (fileName: string) => {
  const lastIndex = fileName.lastIndexOf('.');
  if (lastIndex === -1) {
    return ""; // No file extension found
  }
  return fileName.slice(lastIndex + 1).toLowerCase();
};



// eslint-disable-next-line array-callback-return
const setuprows = (docsinmeeting  || []).map((item:any, index:any) => {

  //console.log(item)


  let konvertischecked:boolean = false
  if (docstoconvert !== undefined){
    konvertischecked = docstoconvert.some((item1: { resourceId: any; }) => item1.resourceId === item.resourceId)
  }




  // check if user are selected to sign the document
  let havesigners = false;
 
  const usersigncount = userhavetosigndocs.find((itemdata: { resourceId: any; }) => itemdata.resourceId === item.resourceId);

  if (usersigncount !== undefined){
    if (usersigncount.user.length >= 1){
      havesigners = true
    } else {
      havesigners = false
      item.isSigPrepared = false
    }
 }

 //console.log("initdocsinmeeting", initdocsinmeeting)
 //console.log(havesigners)

  let pdf = false
  let fileext = ""

  if (isPDF(item.name)){
    pdf = true
  } else {
    fileext = getFileExtension(item.name)
  }





  //console.log(fileext)
  if (fileext !== "zip"){
    return(
      <React.Fragment key={item.id || index}>
      <Grid.Col span={4}>
        <Group spacing="xs">
        {pdf && <PdfLabel isPDFA1b={item.isPDFA1b} signatureCount={item.signatureCount} resourceId={item.resourceId}  />} 
        {fileext !== "" && <Badge color="dark" variant="filled" size="sm" radius="sm"  >{fileext}</Badge>}
        {item.signatureCount >= 1 &&  
        <Indicator  
           size={14} 
           offset={3}  
           label={item.signatureCount} 
           styles={(theme) => ({
            indicator: {
              fontSize: '6px',
            },
          })}
           >
          <div className={classes.margintop}><DiscountCheck size={18} /></div>
        </Indicator>
        }
        {item.name} 
        </Group> 
      </Grid.Col>
     
      <Grid.Col span={1}> 
        <Checkbox className={classes.pafleft2} checked={item.isToBeSigned} onChange={(event) => handleisToBeSigned(event.currentTarget.checked, index)} />
        </Grid.Col> 
         <Grid.Col span={1}> <Checkbox  className={classes.pafleft2} checked={item.isToBeRead} onChange={(event) => handleisToRead(event.currentTarget.checked, index)} /> </Grid.Col>
        <Grid.Col span={1}> 
        {!item.isPDFA1b && pdf &&
          <Checkbox className={classes.pafleft10} checked={konvertischecked} onChange={(event) => handleisToBeConverted(event.currentTarget.checked, item.resourceId, item.signatureCount)}   
      />
      }
      </Grid.Col> 
        
 
     
      
 
     
       <Grid.Col span={1}>
       {pdf && havesigners && !disablesigblock &&
          <SetupPrepareDocs resourceId={item.resourceId} isSigPrepared={item.isSigPrepared}  drnId={meetinginfo.drnId}/>
        }
        </Grid.Col>
    
      
      <Grid.Col span={4}><SetupUserToDocs resourceId={item.resourceId} setdisable={!item.isToBeSigned} drnId={meetinginfo.drnId} sendsetmeeting={sendsetmeeting}/></Grid.Col>

      </React.Fragment>
    )
  }
  
});

return (
    <>
  
   <Group position="center"><strong>{intl.get('SETUP_ALIAS_HEAD')}</strong></Group>
   <hr />
   <Grid >
      <Grid.Col span={6}> <TextInput placeholder={intl.get('SETUP_ALIAS_PH_NACHNAME')} onChange={(event) => setFamname(event.currentTarget.value)} /></Grid.Col>
      <Grid.Col span={6}> <TextInput placeholder={intl.get('SETUP_ALIAS_PH_VORNAME')} onChange={(event) => setVorname(event.currentTarget.value)} /> </Grid.Col>
    </Grid>
      <br /><br />

      <Tabs defaultValue="docs">
      <Tabs.List>
        <Tabs.Tab value="docs" icon={<FileText size="0.8rem" />}>{intl.get('SETUP_DOC_TAB')}</Tabs.Tab>
        {nostapelshow &&
         <Tabs.Tab value="ssig" icon={<Stack2 size="0.8rem" />}>{intl.get('SETUP_STAPEL_TAB')}</Tabs.Tab>
        }
        <Tabs.Tab value="user" icon={<Users size="0.8rem" />}>{intl.get('SETUP_USER_TAB')}</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="docs" pt="xs">

   <Group position="center"><strong>{intl.get('SETUP_MEETING_HEADLINE')}: {meetinginfo.title}</strong></Group>
   <hr />
    <Grid >
    <Grid.Col span={4}><FileText /> {intl.get('SETUP_MEETING_DOCNAME')}</Grid.Col>
        
        <Grid.Col span={1}> <Tooltip label={intl.get('SETUP_TT_PEN')} multiline={true}><span><Pencil /></span></Tooltip> </Grid.Col>
        <Grid.Col span={1}><Tooltip label={intl.get('SETUP_TT_STAPEL')} multiline={true}><span><Article /></span></Tooltip>  </Grid.Col>
        <Grid.Col span={1}><Tooltip label={intl.get('SETUP_TT_KONVERT')} multiline={true}><span><ArrowUpCircle /></span></Tooltip> </Grid.Col>
          {!disablesigblock &&
          <Grid.Col span={1}><Tooltip label={intl.get('SETUP_TT_DIGBLOCK')} multiline={true}><span><FileSettings /></span></Tooltip> </Grid.Col>
          }
        <Grid.Col span={4}><SetupUserToDocsHeader docsinmeeting={docsinmeeting} /></Grid.Col>
            {disable && !disableonSigSetup &&
              <Grid.Col span={12}>
                 <Loader color="red" size="xl" />
            </Grid.Col>
          }
       </Grid> 

       <Grid className={classes.selectallrow} align="center">
        <Grid.Col span={4}>{intl.get('SETUP_SELECTALL')}</Grid.Col>
        <Grid.Col span={1}> <Tooltip label={intl.get('SETUP_SELECTALL')} multiline={true}><span><Checkbox size="md" className={classes.pafleft2} checked={allToBeSigned} onChange={(event) => handleSelectAllToBeSigned(event.currentTarget.checked)} styles={{ input: { cursor: 'pointer', borderColor: allToBeSigned ? 'red' : 'green', borderWidth: 2 } }} /></span></Tooltip> </Grid.Col>
        <Grid.Col span={1}><Tooltip label={intl.get('SETUP_SELECTALL')} multiline={true}><span><Checkbox size="md" className={classes.pafleft2} checked={allToBeRead} onChange={(event) => handleSelectAllToBeRead(event.currentTarget.checked)} styles={{ input: { cursor: 'pointer', borderColor: allToBeRead ? 'red' : 'green', borderWidth: 2 } }} /></span></Tooltip>  </Grid.Col>
        <Grid.Col span={1}> </Grid.Col>
        <Grid.Col span={1}> </Grid.Col>
        <Grid.Col span={4}><SetupUserToDocsHeader docsinmeeting={docsinmeeting} checkboxesOnly /></Grid.Col>
      </Grid>

       {!scroll &&
        <Grid className={classes.minheight}>
          {setuprows}
        </Grid>
       }

       {scroll &&
       <ScrollArea h={screenHeight} type="scroll">
        <Grid className={classes.minheight}>
            {setuprows}
        </Grid>
       </ScrollArea>
       }
      
       
     
      <hr />
      {pdfhavesigns &&
      <>
        <Alert  title={intl.get('SETUP_MEETING_ALERT_DOCHAVESIGNS_HEAD')} color="red">
        <Grid >
          <Grid.Col span={8}>
          {intl.get('SETUP_MEETING_ALERT_DOCHAVESIGNS_CONTENT')}
          </Grid.Col>
          <Grid.Col span={4}> 
            <Button fullWidth color="green" onClick={removepdfwithsigns}>{intl.get('SETUP_MEETING_ALERT_DOCHAVESIGNS_BUTTON')}</Button>
          </Grid.Col>
        </Grid>
        </Alert>
        <hr />
      </>
      }

    </Tabs.Panel>
    {nostapelshow && 
     <Tabs.Panel value="ssig" pt="xs">
       <SetupStapelSign setDisableonSigSetup={setDisableonSigSetup} initdocsinmeeting={initdocsinmeeting} />
       <hr /> 
      </Tabs.Panel>
   }
      <Tabs.Panel value="user" pt="xs">
        <SetupUserToIdentify />
      </Tabs.Panel>
    </Tabs>  
      
  
      <Group position="center">
      <Button onClick={()=>sendsetmeeting(true)} disabled={disable}> {intl.get('SETUP_MEETING_BUTTON_SAVE')}</Button>
      </Group>
  

      <Modal
        title=""
        opened={opened}
        onClose={handleCloseSigninfo}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          <Text>{intl.get('SETUP_MEETING_MODAL_DOCHAVESIGNS')}</Text>
          <hr />
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={confirmforcekonvert}>{intl.get('SETUP_MEETING_MODAL_DOCHAVESIGNS_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="red" onClick={handleCloseSigninfo} variant="light">{intl.get('SETUP_MEETING_MODAL_DOCHAVESIGNS_NO')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 
   
   

       

        </>



  )
 
}


export default SetupMeeting;